import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { me as fetchMe, clearToken, getToken, logout as apiLogout } from "../lib/authApi";

const Ctx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) { setAdmin(null); setLoading(false); return; }
    try {
      const a = await fetchMe();
      setAdmin(a);
    } catch {
      clearToken(); setAdmin(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  // v0.6.8 fix — actually revoke the token server-side (see
  // lib/authApi.js's logout()) instead of only clearing it locally.
  // Local state clears immediately regardless of how the network call
  // resolves, so the UI stays snappy and a signed-out user is never
  // stuck waiting on it.
  //
  // A1-93 (9) — and forget this person's workflow: the calc this tab had
  // open, the input cache and the client choice. WorkflowProvider clears
  // its in-memory state when `admin` goes null; these keys would otherwise
  // re-open it on the next page load for whoever signs in next.
  const signout = () => {
    try {
      sessionStorage.removeItem("vat.calcId");
      localStorage.removeItem("vat.workflowInputs");
      localStorage.removeItem("vat.selectedClientId");
    } catch { /* storage unavailable — nothing to forget */ }
    setAdmin(null);
    apiLogout();
  };

  return (
    <Ctx.Provider value={{ admin, setAdmin, loading, refresh, signout }}>
      {children}
    </Ctx.Provider>
  );
};

export const useAuth = () => useContext(Ctx);
